<template>
  <div class="sign-pg">
    <div class="sign-row">
      <div class="sign-form-top">
        <h2>{{ $t('Вход в портал') }}</h2>
        <p>{{ $t('Введите E-mail/Логин') }}</p>
      </div>
      <form @submit.prevent="login">
        <div class="form-group">
          <input
            id="username"
            type="text"
            v-model.trim="username"
            class="form-control"
            :class="{
              invalid:
                ($v.username.$dirty && !$v.username.required) ||
                ($v.username.$dirty && !$v.username.email)
            }"
            placeholder="Email/Логин"
          />
          <small
            class="helper-text invalid"
            v-if="$v.username.$dirty && !$v.username.required"
          >
            {{ $t('Поле Email/Логин не должно быть пустым') }}
          </small>
          <small
            class="helper-text invalid"
            v-else-if="$v.username.$dirty"
          >
            {{ $t('Введите корректный Email/Логин') }}
          </small>
        </div>
        <div class="form-group password">
          <div style="position: relative;">
            <input
              id="password"
              :type="passwordFieldType"
              v-model.trim="password"
              class="form-control"
              :class="{
                invalid:
                  ($v.password.$dirty && !$v.password.required) ||
                  ($v.password.$dirty && !$v.password.minLength)
              }"
              :placeholder="$t('Пароль')"
            />
            <i
              :class="[
                showPassword ? 'pro-icon-eye-show' : 'pro-icon-eye-hide'
              ]"
              @click="showPassword = !showPassword"
            />
          </div>
          <small
            class="helper-text invalid"
            v-if="$v.password.$dirty && !$v.password.required"
          >
            {{ $t('Введите пароль') }}
          </small>
          <small
            class="helper-text invalid"
            v-else-if="$v.password.$dirty && !$v.password.minLength"
          >
            {{ $t('Пароль должен быть') }}
            {{ $v.password.$params.minLength.min }} {{ $t('символов') }}. {{ $t('Сейчас он') }}
            {{ password.length }}
          </small>
        </div>
        <button class="btn btn-default grad" type="submit">{{ $t('Войти') }}</button>
        <div class="sign-form-bottom">
          <router-link :to="$i18nRoute({ name: 'send-email' })">{{ $t('Забыли пароль') }}?</router-link>
          <div class="no-accaunt">
            <p>{{ $t('Не зарегистрированы') }}?</p>
            <router-link :to="$i18nRoute({ name: 'register' })">{{ $t('Создайте аккаунт сейчас') }}</router-link>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { required, minLength } from 'vuelidate/lib/validators'
  import messages from '@/utils/messages'

  export default {
    name: 'login',
    data: () => ({
      username: '',
      password: '',
      showPassword: false
    }),
    metaInfo () {
      return {
        title: this.$i18n.t('LoginTitleSEO'),
        meta: [{
          vmid: 'description',
          name: 'description',
          content: this.$i18n.t('LoginDescriptionSEO'),
        }, {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$i18n.t('LoginKeywordsSEO'),
        }]
      }
    },
    validations: {
      username: { required },
      password: { required, minLength: minLength(8) }
    },
    computed: {
      passwordFieldType () {
        return this.showPassword ? 'text' : 'password'
      }
    },
    mounted () {
      if (messages[this.$route.query.message]) {
        this.$message(messages[this.$route.query.message])
      }
    },
    methods: {
      async login () {
        if (this.$v.$invalid) {
          this.$v.$touch()
          return
        }

        const loginForm = {
          username: this.username,
          password: this.password
        }

        try {
          await this.$store.dispatch('login', loginForm)
          const redirect = sessionStorage.getItem('redirectPath')
          redirect ? await this.$router.push(redirect) : await this.$router.go(-1)
          //Cleanup redirectPath
          sessionStorage.removeItem('redirectPath')
        } catch (error) {}
      }
    }
  }
</script>
